
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPurRequestAppGrid extends Serenity.EntityGrid<PoPurRequestAppRow, any> {
        protected getColumnsKey() { return PoPurRequestAppColumns.columnsKey; }
        protected getDialogType() { return PoPurRequestAppDialog; }
        protected getIdProperty() { return PoPurRequestAppRow.idProperty; }
        protected getInsertPermission() { return PoPurRequestAppRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPurRequestAppRow.localTextPrefix; }
        protected getService() { return PoPurRequestAppService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
    }
}